// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react'
import tw from 'tailwind-styled-components'

type Props = {
  $muted?: boolean
  disabled?: boolean
}

const TableRow = tw.tr<Props>`
  ease-in-out
  transition-300
  transition-opacity

  ${(props: Props) => props.disabled && `opacity-25`}

  ${(props: Props) =>
    props.$muted &&
    `
    bg-gray-50
  `}
`

export default TableRow
